// ============================================
// coop-qr.js
// PATCH DATE: 2026-04-14
// PATCHES INCLUDED:
// 1. BTC/PHP display switching in popup
// 2. Vehicle rental product-view form integration
// 3. Centralized QR text configuration for easier editing later
// 4. Flow label support for CoopCar
// SCOPE:
// - No new popup
// - No new JS file
// - No change to core QR flow
// - No change to unrelated UI text
// ============================================

var DEFAULT_COOPPAY_DESTINATION = 'coop@isle.ph';
var DEFAULT_LIGHTNING_DESTINATION = 'coop@coinos.io';
var GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzVA62DHIO1GnUt1EEOaytthXqeM_TnWgvoQ9GyDCNN0yb-UcoenKOefhu5gcsiw-3-/exec';

var currentProduct = {
  id: '',
  title: '',
  handle: '',
  vendor: '',
  price: '',
  tags: [],
  cooppayDestination: '',
  lightningDestination: '',
  isCartPayment: false,
  cartHasVpi: false,
  cartHasVehicle: false,
  cartToken: '',
  cartItemCount: 0,
  cartTotal: ''
};

var currentMode = 'cooppay';
var currentFormStage = 'delivery';

var collectedData = {
  vin: {},
  vehicle: {},
  delivery: {}
};

/* =========================
   CENTRALIZED QR TEXT CONFIG
   EDIT HERE LATER
========================= */

var QR_TEXT = {
  product: {
    cooppay: {
      caption: 'Best for CoopPay users. Scan with CoopPay to pay instantly. Zero fee, peso-to-peso payments.',
      note: 'This payment contributes to a procurement run. Runs execute once totals reach ₱20,000. Product payment only. Shipping fees calculated separately after review of delivery address.'
    },
    coinos: {
      caption: 'For other Lightning wallets, e.g. Blink, Strike, Aqua, etc. Cooperative purchasers who prefer instant zero-fee peso to peso may prefer payments via CoopPay.',
      note: 'This payment contributes to a procurement run. Runs execute once totals reach ₱20,000. Product payment only. Shipping fees will be calculated separately after we review your delivery address.'
    }
  },

  vin: {
    cooppay: {
      caption: 'Best for CoopPay users. Scan with CoopPay to pay instantly. Zero fee, peso-to-peso payments.',
      note: 'CoopPay is the world\'s first Lightning super app for cooperatives. Built by OneCoopTech, the first and only technology service federation in the Philippines.'
    },
    coinos: {
      caption: 'For other Lightning wallets, e.g. Blink, Strike, Aqua, etc. Cooperative purchasers who prefer instant zero-fee peso to peso may prefer payments via CoopPay.',
      note: 'CoopPay is the world\'s first Lightning super app for cooperatives. Built by OneCoopTech, the first and only technology service federation in the Philippines.'
    }
  },

  vehicle: {
    cooppay: {
      caption: 'Best for CoopPay users. Scan with CoopPay to pay instantly. Zero fee, peso-to-peso payments.',
      note: 'CoopPay is the world\'s first Lightning super app for cooperatives.  Built by OneCoopTech, the first and only technology service federation in the Philippines.'
    },
    coinos: {
      caption: 'For other Lightning wallets, e.g. Blink, Strike, Aqua, etc. Cooperative purchasers who prefer instant zero-fee peso to peso may prefer payments via CoopPay.',
      note: 'CoopPay is the world\'s first Lightning super app for cooperatives.  Built by OneCoopTech, the first and only technology service federation in the Philippines.'
    }
  },

  cart: {
    cooppay: {
      caption: 'Scan with your CoopPay to pay instantly. No fees.',
      note: 'Pay your cart total. Delivery fee to be determined after reviewing your address.'
    },
    coinos: {
      caption: 'Scan with your Lightning wallet to pay instantly from anywhere in the world.',
      note: 'Pay your cart total. Delivery fee to be determined after reviewing your address.'
    }
  }
};




/* =========================
   CORE HELPERS
========================= */

function ensureModalAtBodyLevel() {
  var modal = document.getElementById('coopQRModal');
  if (!modal) return;

  var openCartDrawerDialog = document.querySelector('.cart-drawer__dialog[open]');
  var targetParent = openCartDrawerDialog || document.body;

  if (modal.parentNode !== targetParent) {
    targetParent.appendChild(modal);
  }
}

function resetCoopQRModalState() {
  var summary = document.getElementById('coopQRCartSummary');
  var totalEl = document.getElementById('coopQRCartTotal');

  if (summary) summary.style.display = 'none';
  if (totalEl) totalEl.innerHTML = '₱0.00';

  currentProduct.cartTotal = '';
}

function isCartPayment() {
  return currentProduct.isCartPayment === true;
}

function hasTag(tag) {
  return currentProduct.tags.indexOf(tag) !== -1;
}

function isVehicleRental() {
  if (isCartPayment()) {
    return currentProduct.cartHasVehicle === true;
  }
  return hasTag('vehicle_rent');
}

function isVPIContext() {
  if (isCartPayment()) return currentProduct.cartHasVpi === true;
  return hasTag('vpi');
}

function saveCurrentStepData() {

  if (currentFormStage === 'vin') {
    collectedData.vin = {
      vin: document.getElementById('vpiVin')?.value || '',
      email: document.getElementById('vpiEmail')?.value || '',
      part_reference: document.getElementById('vpiPartReference')?.value || '',
      note: document.getElementById('vpiNotes')?.value || ''
    };
  }

  else if (currentFormStage === 'vehicle') {
    collectedData.vehicle = {
      name: document.getElementById('vrName')?.value || '',
      mobile: document.getElementById('vrMobile')?.value || '',
      email: document.getElementById('vrEmail')?.value || '',
      pickup: document.getElementById('vrPickup')?.value || '',
      dropoff: document.getElementById('vrDropoff')?.value || '',
      license: document.getElementById('vrLicense')?.value || '',
      notes: document.getElementById('vrNotes')?.value || ''
    };
  }

  else {
    collectedData.delivery = {
      name: document.getElementById('buyerName')?.value || '',
      mobile: document.getElementById('buyerMobile')?.value || '',
      address: document.getElementById('buyerAddress')?.value || '',
      note: document.getElementById('buyerNote')?.value || ''
    };
  }
}

/* =========================
   FLOW SEQUENCE ENGINE
   (NEW — controls cart form order)
========================= */

function getFormSequence() {
  var seq = [];

  if (currentProduct.cartHasVpi) {
    seq.push('vin');
  }

  if (currentProduct.cartHasVehicle) {
    seq.push('vehicle');
  }

  // 🔴 ONLY add delivery if real regular items exist
  if (currentProduct.cartHasRegular) {
    seq.push('delivery');
  }

  return seq;
}

function determineInitialFormStage() {

  // 🔴 PRODUCT VIEW (UNCHANGED BEHAVIOR)
  if (!currentProduct.isCartPayment) {
    if (isVehicleRental()) return 'vehicle';
    if (isVPIContext()) return 'vin';
    return 'delivery';
  }

  // 🔴 CART VIEW (NEW LOGIC)
  var seq = getFormSequence();

  // start from first item in sequence
  return seq.length ? seq[0] : 'delivery';
}

function getQRTextContext() {
  if (isCartPayment()) return 'cart';
  if (isVPIContext()) return 'vin';
  if (isVehicleRental()) return 'vehicle';
  return 'product';
}

function applyQRText() {
  var captionEl = document.getElementById('coopQRCaption');
  var noteEl = document.getElementById('coopQRShippingNote');
  var footnoteEl = document.getElementById('coopQRFootnote');

  if (!captionEl || !noteEl) return;

  var context = getQRTextContext();
  var mode = currentMode === 'coinos' ? 'coinos' : 'cooppay';
  var cfg = QR_TEXT[context][mode];

  captionEl.textContent = cfg.caption;
  noteEl.textContent = cfg.note;

  if (footnoteEl) {
    footnoteEl.textContent = '';
    footnoteEl.style.display = 'none';
  }
}

/* =========================
   AMOUNT DISPLAY LOGIC
   PATCH: remove DOM price source → use state only
========================= */

function formatPeso(raw) {
  if (!raw) return null;

  var num = parseFloat(raw);
  if (isNaN(num)) return null;

  var pesos = num / 100;

  return '₱' + pesos.toLocaleString('en-PH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

function updateDisplayedAmount() {
  var totalEl = document.getElementById('coopQRCartTotal');
  var summary = document.getElementById('coopQRCartSummary');

  if (!totalEl || !summary) return;

  var phpValue = null;

  // ✅ KEEP: cart logic (already correct)
  if (currentProduct.isCartPayment && currentProduct.cartTotal) {
    phpValue = currentProduct.cartTotal;

  // 🔴 FIX: replace DOM lookup with state-based price
  } else {
    phpValue = formatPeso(currentProduct.price);
  }

  if (!phpValue) {
    summary.style.display = 'none';
    return;
  }

  summary.style.display = 'block';

  // ✅ KEEP: BTC logic untouched
  if (currentMode === 'coinos') {
    var btcBlock = document.querySelector('[data-btc-price]');
    var btcHTML = btcBlock ? btcBlock.innerHTML : '';

    if (btcHTML && btcHTML.trim() !== '') {
      totalEl.innerHTML = btcHTML;
    } else {
      totalEl.textContent = phpValue;
    }
  } else {
    totalEl.textContent = phpValue;
  }
}

/* =========================
   FLOW LABEL
========================= */

function updateFlowLabel() {
  var el = document.getElementById('coopQRFlowLabel');
  if (!el) return;

  var modeText = currentMode === 'coinos' ? 'Lightning' : 'CoopPay';
  var flowText;

  if (currentFormStage === 'vin') {
    flowText = 'VIN Dashboard';
  } else if (isVehicleRental()) {
    flowText = 'CoopCar';
  } else {
    flowText = 'Delivery';
  }

  el.textContent = modeText + ' → ' + flowText;
}

/* =========================
   STEP INDICATOR
========================= */

function updateStepIndicator() {
  var stepEl = document.getElementById('coopQRStep');
  var imageWrap = document.getElementById('coopQRImageWrap');
  var formWrap = document.getElementById('coopQRFormWrap');

  if (!stepEl) return;

  // 🔴 Detect actual UI stage, not just currentFormStage
  var isPaymentStep = imageWrap && imageWrap.style.display !== 'none';
  var isFormStep = formWrap && formWrap.style.display === 'block';

  var seq;

  // 🔴 Product view = always single-kind
  if (!isCartPayment()) {
    seq = [currentFormStage];
  } else {
    seq = getFormSequence();
  }

  var totalSteps = seq.length + 1;

  // 🔴 Payment screen is always Step 1
  if (isPaymentStep && !isFormStep) {
    stepEl.textContent = 'Step 1 of ' + totalSteps + ' · Payment';
    return;
  }

  // 🔴 Form screens start at Step 2
  var idx = seq.indexOf(currentFormStage);
  var stepNumber = idx !== -1 ? idx + 2 : 2;

  var label = '';
  if (currentFormStage === 'vin') label = 'VIN';
  else if (currentFormStage === 'vehicle') label = 'Vehicle';
  else label = 'Delivery';

  stepEl.textContent = 'Step ' + stepNumber + ' of ' + totalSteps + ' · ' + label;
}

/* =========================
   QR + MODE
========================= */

function renderQRCode(text) {
  var qrContainer = document.getElementById('coopQRImage');
  qrContainer.innerHTML = '';
  new QRCode(qrContainer, { text: text, width: 228, height: 228 });
}

function setCoopQRMode(mode) {
  currentMode = mode;

  var coopTab = document.getElementById('coopQRTabCoopPay');
  var lightningTab = document.getElementById('coopQRTabCoinos');
  var title = document.getElementById('coopQRTitle');

  if (coopTab && lightningTab) {
    coopTab.classList.toggle('is-active', mode === 'cooppay');
    lightningTab.classList.toggle('is-active', mode === 'coinos');
  }

  if (title) {
    title.textContent = 'QuickPay · CoopPay';
  }

  if (mode === 'coinos') {
    renderQRCode(currentProduct.lightningDestination);
  } else {
    renderQRCode(currentProduct.cooppayDestination);
  }

  applyQRText();
  updateFlowLabel();
  updateDisplayedAmount();
}

function renderFormFields() {
  var wrap = document.getElementById('coopQRDynamicFields');
  var submitButton = document.getElementById('coopQRSubmitButton');

  // 🔴 FIX: vehicle must work in cart when stage === 'vehicle'
  if (
    (isCartPayment() && currentFormStage === 'vehicle') ||
    (isVehicleRental() && !isCartPayment())
  ) {
    wrap.innerHTML = `
      <input type="text" id="vrName" class="coop-qr-input" placeholder="Full name" required>
      <input type="text" id="vrMobile" class="coop-qr-input" placeholder="Mobile number" required>
      <input type="email" id="vrEmail" class="coop-qr-input" placeholder="Email address" required>
      <input type="text" id="vrPickup" class="coop-qr-input" placeholder="Pickup address" required>
      <input type="text" id="vrDropoff" class="coop-qr-input" placeholder="Dropoff address" required>
      <input type="text" id="vrLicense" class="coop-qr-input" placeholder="Driver’s license number" required>
      <input type="text" id="vrNotes" class="coop-qr-input" placeholder="Notes (optional)">
    `;

    submitButton.textContent = 'Submit Vehicle Rental Details';

  } else if (currentFormStage === 'vin') {
    wrap.innerHTML = `
      <input type="text" id="vpiVin" class="coop-qr-input" placeholder="VIN" required>
      <input type="email" id="vpiEmail" class="coop-qr-input" placeholder="Email" required>
      <input type="text" id="vpiPartReference" class="coop-qr-input" placeholder="Part reference (optional)">
      <textarea id="vpiNotes" class="coop-qr-input coop-qr-textarea" placeholder="Notes (optional)"></textarea>
    `;

    submitButton.textContent = isCartPayment()
      ? 'Continue to Delivery'
      : 'Submit VIN Details';

  } else {
    wrap.innerHTML = `
      <input type="text" id="buyerName" class="coop-qr-input" placeholder="Your name" required>
      <input type="text" id="buyerMobile" class="coop-qr-input" placeholder="Mobile number" required>
      <textarea id="buyerAddress" class="coop-qr-input coop-qr-textarea" placeholder="Delivery address" required></textarea>
      <textarea id="buyerNote" class="coop-qr-input coop-qr-textarea" placeholder="Optional note"></textarea>
    `;

    submitButton.textContent = 'Submit Delivery Details';
  }

  updateFlowLabel();
  updateStepIndicator();
}

/* =========================
   OPEN MODAL
========================= */

function openCoopQRModal(button) {

  var successEl = document.getElementById('coopQRSuccess');
  var successTextEl = document.getElementById('coopQRSuccessText');
  var formWrap = document.getElementById('coopQRFormWrap');

if (successEl) {
  successEl.style.display = 'none';
  successEl.innerHTML = '';
}
  if (successTextEl) successTextEl.textContent = '';
  if (formWrap) formWrap.style.display = 'block';

  ensureModalAtBodyLevel();
  resetCoopQRModalState();

  collectedData = {
  vin: {},
  vehicle: {},
  delivery: {}
};

  // 🔴 FORCE RESET PRICE EVERY OPEN
currentProduct.price = null;

  currentProduct.id = button.dataset.productId || '';
  currentProduct.title = button.dataset.productTitle || '';
  currentProduct.handle = button.dataset.productHandle || '';
  currentProduct.vendor = button.dataset.productVendor || '';

// 🔴 ALWAYS GET ACTIVE SHOPIFY VARIANT
var variantIdInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');

if (variantIdInput && variantIdInput.value && window.product && window.product.variants) {
  var variantId = String(variantIdInput.value);

  var variant = window.product.variants.find(function(v) {
    return String(v.id) === variantId;
  });

  if (variant && variant.price != null) {
    currentProduct.price = variant.price;
  } else {
    currentProduct.price = button.dataset.productPrice || '';
  }
} else {
  currentProduct.price = button.dataset.productPrice || '';
}

  currentProduct.tags = (button.dataset.productTags || '')
    .split(',')
    .map(function (t) { return t.trim().toLowerCase(); })
    .filter(Boolean);

  currentProduct.cooppayDestination = button.dataset.cooppayDestination || DEFAULT_COOPPAY_DESTINATION;
  currentProduct.lightningDestination = button.dataset.lightningDestination || DEFAULT_LIGHTNING_DESTINATION;

  currentProduct.isCartPayment = button.dataset.cartMode === 'true';
  currentProduct.cartHasVpi = button.dataset.cartHasVpi === 'true';
  currentProduct.cartHasVehicle = button.dataset.cartHasVehicle === 'true';
  currentProduct.cartHasRegular = button.dataset.cartHasRegular === 'true';

  currentProduct.cartItemsSummary = button.dataset.cartItemsSummary || '';

  currentFormStage = determineInitialFormStage();

  document.getElementById('coopQRModal').style.display = 'flex';
  document.body.style.overflow = 'hidden';

  document.getElementById('coopQRFormWrap').style.display = 'none';
  document.getElementById('coopQRImageWrap').style.display = 'block';
  document.getElementById('coopQRPaidButton').style.display = 'block';

  document.getElementById('coopQRCaption').style.display = 'block';
  document.getElementById('coopQRShippingNote').style.display = 'block';
  document.getElementById('coopQRFootnote').style.display = 'none';

  document.getElementById('coopQRTabCoopPay').style.display = 'inline-block';
  document.getElementById('coopQRTabCoinos').style.display = 'inline-block';

  renderFormFields();
  setCoopQRMode('cooppay');

  var source = document.querySelector('.cart-totals__total-value');
  var summary = document.getElementById('coopQRCartSummary');
  var totalEl = document.getElementById('coopQRCartTotal');

  if (source && summary && totalEl && currentProduct.isCartPayment) {
    var value = source.textContent.trim().replace('PHP', '').trim();
    totalEl.textContent = value;
    currentProduct.cartTotal = value;
    summary.style.display = 'block';
  } else {
    if (summary) summary.style.display = 'none';
  }

  updateDisplayedAmount();
}

/* =========================
   CONFIRM PAYMENT
========================= */

document.addEventListener('click', function (e) {
  if (e.target && e.target.id === 'coopQRPaidButton') {
    document.getElementById('coopQRImageWrap').style.display = 'none';
    document.getElementById('coopQRCaption').style.display = 'none';
    document.getElementById('coopQRFootnote').style.display = 'none';
    document.getElementById('coopQRPaidButton').style.display = 'none';

    document.getElementById('coopQRTabCoopPay').style.display = 'none';
    document.getElementById('coopQRTabCoinos').style.display = 'none';

    document.getElementById('coopQRShippingNote').style.display = 'none';
    document.getElementById('coopQRCartSummary').style.display = 'none';

    renderFormFields();
    document.getElementById('coopQRFormWrap').style.display = 'block';
  }
});
/* =========================
   SUBMIT FORM → GOOGLE SHEET (FINAL)
========================= */

document.addEventListener('click', function (e) {
  if (e.target && e.target.id === 'coopQRSubmitButton') {
    e.preventDefault();

    // 🔴 CART-ONLY FLOW CONTROL (DO NOT TOUCH PRODUCT FLOW)

if (isCartPayment()) {

// 🔴 DYNAMIC FLOW TRANSITION
var seq = getFormSequence();
var idx = seq.indexOf(currentFormStage);

// move to next stage if exists
if (idx !== -1 && idx < seq.length - 1) {

  // 🔴 SAVE CURRENT STEP DATA FIRST
  saveCurrentStepData();

  currentFormStage = seq[idx + 1];
  renderFormFields();
  return;
}

}

saveCurrentStepData();

    var payload = {
      product_id: currentProduct.id || '',
      product_title: currentProduct.title || '',
      product_handle: currentProduct.handle || '',
      product_vendor: currentProduct.vendor || '',

      selected_rail: currentMode === 'coinos' ? 'lightning' : 'cooppay',
      selected_destination: currentMode === 'coinos'
        ? currentProduct.lightningDestination
        : currentProduct.cooppayDestination,

   // 🔴 USE STORED DATA (FIX)
buyer_name:
  collectedData.vehicle.name ||
  collectedData.delivery.name || '',

buyer_mobile:
  collectedData.vehicle.mobile ||
  collectedData.delivery.mobile || '',

buyer_address:
  collectedData.vehicle.pickup ||
  collectedData.delivery.address || '',

buyer_note:
  collectedData.vehicle.notes ||
  collectedData.delivery.note || '',

// VIN + vehicle
vin:
  collectedData.vehicle.license ||
  collectedData.vin.vin || '',

part_reference:
  collectedData.vin.part_reference || '',

verification_email:
  collectedData.vehicle.email ||
  collectedData.vin.email || '',

verification_note:
  collectedData.vin.note || '',

delivery_dropoff:
  collectedData.vehicle.dropoff || '',

      page_url: window.location.href,

      is_cart_payment: currentProduct.isCartPayment || false,
      cart_token: currentProduct.cartToken || '',
      cart_item_count: currentProduct.cartItemCount || '',
      cart_total: currentProduct.cartTotal || '',
      cart_items_summary: currentProduct.cartItemsSummary || ''
    };

    fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      body: JSON.stringify(payload)
    })

    .then(function () {

var successText = 'Procurement request submitted';

// 🔴 CART MODE
if (currentProduct.isCartPayment) {
  var kinds = 0;

  if (currentProduct.cartHasVpi) kinds++;
  if (currentProduct.cartHasVehicle) kinds++;
  if (currentProduct.cartHasRegular) kinds++;

  if (kinds === 1) {
    if (currentProduct.cartHasVehicle) {
      successText = 'Vehicle request submitted';
    } else if (currentProduct.cartHasVpi) {
      successText = 'Verification request submitted';
    } else {
      successText = 'Order request submitted';
    }
  }
}

// 🔴 PRODUCT VIEW (unchanged behavior)
else {
  if (isVehicleRental()) {
    successText = 'Vehicle request submitted';
  } else if (isVPIContext()) {
    successText = 'Verification request submitted';
  }
}


      document.getElementById('coopQRFormWrap').style.display = 'none';



var successEl = document.getElementById('coopQRSuccess');

if (successEl) {
successEl.innerHTML = `
  <div class="coop-success">
    <div class="coop-success-icon">✓</div>
    <div class="coop-success-text">${successText}</div>
  </div>
`;

  successEl.style.display = 'block';
}






    })
    .catch(function () {
      alert('Submission failed');
    });
  }
});


/* =========================
   CLOSE
========================= */

function closeCoopQRModal() {
  document.getElementById('coopQRModal').style.display = 'none';
  document.body.style.overflow = '';
}